/** Window event that opens a right-docked source/preview panel in the Ask Moo
 *  host. Kept in its own dependency-free module so leaf components (e.g. action
 *  cards) can dispatch it without importing AskMooIntegrationV2 — which pulls
 *  the heavy @cowbell/moo chat barrel. */
export const MOO_V2_OPEN_SOURCE_PANEL_EVENT = 'moo:v2-open-source-panel';
